export default __webpack_public_path__ + "static/media/gift-cards.5eb701f7.png";